import { Select } from 'antd';
import * as React from 'react';
import { BCCombobox, BCInputMask, IComboboxSelectedChangeEventArgs } from '../index';
import Styles from './assets/style.scss';
import { countries } from './Contents/countries';
import { IPhoneInputProps } from './entities';

import classNames from 'classnames/bind';
const cx = classNames.bind(Styles);

const BCPhoneInput = (props: IPhoneInputProps) => {
	const [focus, setFocus] = React.useState(false);
	const wrapperRef = React.useRef<HTMLDivElement>();

	React.useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	});

	const onChangeCountry = (args: IComboboxSelectedChangeEventArgs) => {
		const item = args.senderArgs?.option;
		const data = countries.find((i: any) => i.key === item.key).name;
		const country = {
			key: item.key,
			text: item.children,
			value: item.value,
			name: data
		};

		props.onChangeCountry?.(country);
	};

	const renderItem = (args: any) => {
		let optionContent: string = args.text + ' ' + args.key;
		if (props.country !== null && props.country?.key === args.key) {
			optionContent = args.key;
		}

		return (
			<Select.Option
				value={args.value}
				key={args.key}
				title={args.text}
			>
				{optionContent}
			</Select.Option>
		);
	};

	const onMouseDown = () => {
		setFocus(true);
	};

	const handleClickOutside = (event: any) => {
		if (wrapperRef && !wrapperRef.current.contains(event.target)) {
			setFocus(false);
		}
	};

	const classNames = cx({
		Wrapper: true,
		onFocus: focus
	});

	let mask = '';
	let country = null;
	let defaultCountry = null;
	if (props.defaultPhoneCode) {
		defaultCountry = countries.find(i => i.key === props.defaultPhoneCode);

		if (defaultCountry) {
			country = defaultCountry;
		}
	}
	return (
		<div
			ref={wrapperRef}
			className={classNames}
			onMouseDown={onMouseDown}
		>
			<BCCombobox
				showSearch
				options={countries}
				value={country}
				disabled={false}
				onSelectedChange={onChangeCountry}
				className={[props.dropDownClassName, Styles.phoneDropdown].join(' ')}
				defaultValue={defaultCountry}
				renderItem={renderItem}
			/>
			<BCInputMask
				mask={mask}
				formatChars={props.formatChars}
				value={props.value}
				size={props.size as 'small' | 'middle' | 'large'}
				disabled={props.disabled}
				onChange={props.onChange}
				className={[props.inputClassName, Styles.maskInput].join(' ')}
			/>
		</div>
	);
};
export default BCPhoneInput;
